import {
	Grid,
	MultiSelect,
	NumberInput,
	TextInput,
	Textarea,
} from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import type { UseFormReturnType } from '@mantine/form';
import {
	IconBrandProducthunt,
	IconCalendar,
	IconMoneybag,
} from '@tabler/icons-react';
import { FormBranchSelector } from '../../../components/form/FormBranchSelector';
import { FormTillSelector } from '../../../components/form/FormTillSelector';
import { inputIconStyle } from '../../../theme/styling/iconStyling';
import { useBranchOptions } from '../../../util/api/commonQueries';
import type { UpsertPosMessageDto } from '../types/PosMessageDto';

interface UpsertPosMessageFormProps {
	form: UseFormReturnType<
		UpsertPosMessageDto,
		(values: UpsertPosMessageDto) => UpsertPosMessageDto
	>;
	inputs: UpsertPosMessageDto;
}

export function UpsertPosMessageForm({
	form,
	inputs,
}: UpsertPosMessageFormProps) {
	const pharmaciesQuery = useBranchOptions();

	return (
		<Grid>
			<Grid.Col span={6}>
				<DateTimePicker
					clearable
					label="Start Date"
					placeholder="Pick start date..."
					leftSection={<IconCalendar {...inputIconStyle} />}
					key={form.key('startDate')}
					{...form.getInputProps('startDate')}
				/>
			</Grid.Col>
			<Grid.Col span={6}>
				<DateTimePicker
					clearable
					label="End Date"
					placeholder="Pick end date..."
					leftSection={<IconCalendar {...inputIconStyle} />}
					key={form.key('endDate')}
					{...form.getInputProps('endDate')}
				/>
			</Grid.Col>

			<Grid.Col span={5}>
				<FormBranchSelector form={form} property={'branchId'} />
			</Grid.Col>
			<Grid.Col span={5}>
				<FormTillSelector
					form={form}
					property={'tillNo'}
					branchId={inputs.branchId}
					branchOptions={pharmaciesQuery.data?.value}
				/>
			</Grid.Col>
			<Grid.Col span={2}>
				<NumberInput
					label={'Quantity'}
					placeholder="Insert amount..."
					fixedDecimalScale
					thousandSeparator=","
					allowDecimal={false}
					allowNegative={false}
					key={form.key('qty')}
					{...form.getInputProps('qty')}
				/>
			</Grid.Col>
			<Grid.Col span={6}>
				<TextInput
					label={'SKUID'}
					placeholder="Insert SKUID..."
					key={form.key('skuid')}
					{...form.getInputProps('skuid')}
					leftSection={<IconBrandProducthunt {...inputIconStyle} />}
				/>
			</Grid.Col>
			<Grid.Col span={6}>
				<NumberInput
					label={'Value'}
					placeholder="Insert value..."
					prefix="£"
					decimalScale={2}
					thousandSeparator=","
					allowDecimal={true}
					allowNegative={false}
					leftSection={<IconMoneybag {...inputIconStyle} />}
					key={form.key('moneyValue')}
					{...form.getInputProps('moneyValue')}
				/>
			</Grid.Col>
			<Grid.Col>
				<MultiSelect
					label="Days Associated with Message"
					placeholder="Select days..."
					data={[
						'Monday',
						'Tuesday',
						'Wednesday',
						'Thursday',
						'Friday',
						'Saturday',
						'Sunday',
					]}
					key={form.key('days')}
					{...form.getInputProps('days')}
				/>
			</Grid.Col>
			<Grid.Col>
				<Textarea
					label={'POS Message'}
					placeholder={'Insert POS message...'}
					resize="vertical"
					minRows={4}
					maxRows={6}
					key={form.key('posMessage')}
					{...form.getInputProps('posMessage')}
				/>
			</Grid.Col>
		</Grid>
	);
}
